import * as Sentry from "@sentry/browser";
// VALIDATE CONDITIONAL HELPERS 
var sentryEnv = process.env.MIX_ENVIRONMENT || 'local'
Sentry.init({
  dsn: 'https://462118091d1544d1a09e2b504bff1da7@o310434.ingest.sentry.io/5320677',
  environment: sentryEnv,
  ignoreErrors: [
    "ResizeObserver loop limit exceeded"
  ],
  beforeSend: function (event, hint) {
    console.error(hint.originalException)
    return event
  }
});


function getAllFormFields () {
  if (!window.formSections) {
    console.log("form validation not implemented here")
    Sentry.captureMessage("form validation not implemented here")
    return []
  }
  return window.formSections.reduce(function (acc, section) {
    var fields = [...acc, ...section.fields]
    return fields
  }, [])
}

function getAllConditionals () {
  return getAllFormFields().filter((field) => field.field_type === 'conditional')
}

function getSubmissionField (field) {
  var formArray  = $('form').serializeArray()
  var nameStr    = 'form_field_' + field.id
  
  var submission = formArray.find(function(fieldSubmission) {
    return fieldSubmission.name === nameStr
  })

  return submission
}

function isRequiredFieldValid(field) {
    var submissionField = getSubmissionField(field);

    if (submissionField && submissionField.value) {
      if (field.field_type === 'multicheckbox' || field.field_type === 'multiselect') {
        try {
            var values = JSON.parse(submissionField.value);
            if (values.length === 0) {
                return [false, Object.assign({}, field, {'errorMessage': 'Please select at least one option for ' + field.label})];
            }
        } catch (e) {
            console.error('Error parsing JSON for field:', field, e);
            return [false, Object.assign({}, field, {'errorMessage': 'Error processing field data.'})];
        }
      }
    }

    return [true, false]; // Properly indicate no errors when validation passes
}

function getAllRequiredVisibleChildFields () {
  // some formSections places come in as childFields and some as child_fields depending on route
  // need to investigate why this is happening
  return getAllVisibleConditionals().reduce((acc, conditional) => {
    var childFieldsObj = conditional.child_fields || conditional.childFields || []
    var childFields = childFieldsObj.filter((childField) => childField.required)
    return [...acc, ...childFields]
  }, [])
}

function getAllVisibleConditionals () {
  return getAllConditionals().filter((field) => {
    var found = field.metadata.conditions.find((condition) => {
      return window.passedConditionals[condition.column]
    })
    return !!found
  })
}

function validateRequiredVisibleChildFields () {
  try { 
    var invalidFields = getAllRequiredVisibleChildFields().map(function (field) {
      var [valid, errorField] = isRequiredFieldValid(field)
      if (valid) return false;
      return errorField
    }).filter(function (field) {
      return field
    })
    return invalidFields
  } catch (e) {
    Sentry.captureException(e)
    return []
  } 
}

export default {
  validateRequiredVisibleChildFields
}